<template>
    <Button
        :label="label"
        :loading="loading"
        :severity="btnSeverity"
        :text="isText"
        :outlined="false"
        :size="btnSize"
        :fluid="fluid"
        :disabled="disabled"
        :type="type"
        :as="as"
        :href="href"
        :target="target"
        :iconPos="iconPos"
        :icon="icon"
        @click="$emit('click', $event)"
    >
        <template #loadingicon>
            <div class="flex justify-center items-center">
                <div class="flex justify-center items-center dots">
                    <div class="dot dot-1" />
                    <div class="dot dot-2" />
                    <div class="dot dot-3" />
                </div>
            </div>
        </template>
        <template
            v-if="icon === null"
            #icon
        >
            <slot name="icon" />
        </template>
        <slot></slot>
    </Button>
</template>

<script>
import Button from 'primevue/button';

export default {
    name: 'YpButton',
    components: {
        Button,
    },
    props: {
        // Button label text
        text: {
            type: String,
        },

        size: {
            type: String,
            default: null,
            validator: (value) => ['sm', 'lg', null].includes(value),
        },

        iconPos: {
            type: String,
            default: 'left',
            validator: (value) => ['left', 'right'].includes(value),
        },

        icon: { type: String, default: null },

        // Define the button variant
        variant: {
            type: String,
            default: 'primary',
            validator: (value) => ['primary', 'secondary', 'tertiary', 'danger', 'danger-secondary'].includes(value),
        },

        // Loading button
        loading: {
            type: Boolean,
            default: false,
        },

        // Type of the button
        type: {
            type: String,
            default: 'button',
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        fluid: {
            type: Boolean,
            default: null,
        },

        as: String,
        href: String,
        target: String,
    },
    emits: ['click'],
    computed: {
        label() {
            return !this.loading ? this.text : null;
        },

        isText() {
            return this.variant === 'tertiary' || this.variant === 'danger-secondary';
        },

        btnSeverity() {
            switch (this.variant) {
                case 'danger-secondary':
                case 'danger':
                    return 'danger';
                case 'primary':
                case 'tertiary':
                default:
                    return null;
                case 'secondary':
                    return this.variant;
            }
        },

        btnSize() {
            const sizeMap = {
                lg: 'large',
                sm: 'small',
            };

            return sizeMap[this.size] || null;
        },
    },
};
</script>

<style lang="scss" scoped>
.-button.loading {
    opacity: 1;
}

.dots {
    line-height: 11px;
    text-indent: 0;

    &.secundary .dot {
        background-color: #141316;
    }
}

.dot {
    width: 8px;
    height: 8px;
    margin: 1px;
    margin-right: 6px;
    background-color: #fff;
    opacity: 1;
    border-radius: 100%;
    display: inline-block;
    animation: bounceDelay 1s infinite ease-in-out;
    animation-fill-mode: both;

    &.dot-2 {
        animation-delay: 0.16s;
    }
    &.dot-3 {
        animation-delay: 0.32s;
    }
}

@keyframes bounceDelay {
    0%,
    80%,
    to {
        opacity: 0.7;
    }
    40% {
        opacity: 1;
    }
}
</style>
